import Animation from './Animation';
import Timer from './Timer';

/**
 * @alias Animation
 * @module Animation
 */
export default {
  Animation,
  Timer
};



// WEBPACK FOOTER //
// ./src/class/Animation/index.js